// Filter source key for this tab's DataTable — the redux slice / filterSourceKey both
// key their per-view filter state off it.
export const MANAGEMENT_PROFILE_FILTER_SOURCE_KEY = 'MANAGEMENT_PROFILE';

// Wire fields whose cells are rendered by a bespoke COMPONENT renderer (see
// managementProfileColumnRenderers). Keyed switch below in that file maps each to its cell.
export const MANAGEMENT_PROFILE_COMPONENT_FIELDS = {
    NAME: 'name',
    TENURE: 'tenure',
    CONTACT: 'contact',
    RISK_INDICATOR_COUNT: 'riskIndicatorCount',
    AML_PEP_RISK_COUNT: 'amlPepRiskCount',
    LEGAL_CASES_COUNT: 'legalCasesCount',
    CREDIT_SCORE: 'creditScore',
} as const;

export type ColumnLockKey = 'riskAlerts' | 'regulatoryChecks' | 'legalCases';

export const LOCKED_COLUMN_TOOLTIPS: Record<ColumnLockKey, string> = {
    riskAlerts: 'Unlock Structure & Relations to view risk alerts',
    regulatoryChecks: 'Unlock Legal & Risk Checks to view regulatory checks',
    legalCases: 'Unlock Legal & Risk Checks to view legal cases',
};

// Maps each lockable base column's wire field to its lock key, so the header decoration
// (headerIcon/showHeaderIcon/headerIconTooltip, D9) can be applied by field to the
// polus-config-sourced columns (the only column source — there is no FE fallback).
export const LOCKABLE_COLUMN_FIELD_TO_LOCK_KEY: Partial<Record<string, ColumnLockKey>> = {
    riskIndicatorCount: 'riskAlerts',
    amlPepRiskCount: 'regulatoryChecks',
    legalCasesCount: 'legalCases',
};

// Key used in headerIconMap (passed to DataTable) for the lock padlock icon.
export const LOCK_HEADER_ICON_KEY = 'LOCK';

export const KARZA_DIN_STEP = 'AION_KARZA_DIN_DETAILS';

export const PROBE_MERGE_WAIT_MS = 30_000;

/**
 * URL flag the Management Profile tab publishes while the Director Details drawer is open, so
 * AskAicaV2 hides its floating icon (see isAnyDrawerOpen). Shared so the two sides can't drift.
 */
export const DIRECTOR_DRAWER_PARAM = 'directorDrawer';
